import { Behavior } from "./Behavior";
import { TransitionOptions } from "./TransitionOptions";
import { MainPageAccessor } from "./MainPageAccessor";
import { TransitionsUtil } from "./TransitionsUtil";

export class TransitionsUtilBehavior extends Behavior {
    protected constructor() {
        super();
    }

    // When sliding in from the left or right, set top so that slideout
    // displays below the page header bar, unless explicitly defined.
    public getVerticalSlideoutTopOffset(options: TransitionOptions): number {
        return options?.coverPageHeader === true ? 0 : MainPageAccessor.pageHeaderHeight;
    }

    get type(): string {
        return "TransitionsUtil";
    }
}

TransitionsUtilBehavior.register();
